export var CLASS_NAME_SHOW = 'show';
export var CLASS_NAME_FADE = 'fade';


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/constants/classes.js
// module id = 1447
// module chunks = 1